module.exports = __webpack_public_path__ + "img/statue-mana.feb2e9fe.png";